import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const productPersistConfig = {
  key: "product",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const cateogoryPersistConfig = {
  key: "category",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const statPersistConfig = {
  key: "stat",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const cartPersistConfig = {
  key: "posCart",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const itemPersistConfig = {
  key: "item",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const choiceGroupPersistConfig = {
  key: "choiceGroup",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const menuPersistConfig = {
  key: "menu",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const areaPersistConfig = {
  key: "area",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const desiginationPersistConfig = {
  key: "desigination",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const venueUserPersistConfig = {
  key: "venueUser",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const venuePersistConfig = {
  key: "venue",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const tablePersistConfig = {
  key: "table",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({});

export default rootReducer;
